import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemFieldTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  fieldTypes: {}
};
const fetchFieldTypes = async () => {
  const fieldTypes = await SystemFieldTypes.getAllFieldTypes();
  return { fieldTypes };
};
const useFieldTypesForMappings = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["fieldTypeOptions"],
    queryFn: () => defaultOnError(
      fetchFieldTypes(),
      "Loading field type options failed with status",
      "Could not load field type options"
    ),
    placeholderData: keepPreviousData
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading
  };
};
export default useFieldTypesForMappings;
